import * as type from '@/constant/redux-const';
import { DEFAULT_PAGE_SIZE, PromotionStatus, PromotionStatusText } from '@/utils/constant';
import { JETCARD_STATUS } from '@/constant/enum';

export const initialTermsFilter = {
  name: '',
};

export const initialTermsDataState = {
  filter: {
    filters: [],
    logic: 'and',
  },
  sort: [ { field: 'name', dir: 'desc' } ],
  take: DEFAULT_PAGE_SIZE,
  skip: 0,
};

export const initialContactJetCardFilter = {
  status: [
    {
      id: 3,
      text: JETCARD_STATUS.LIVE,
      expanded: true,
      checkIndeterminateField: false,
    },
    {
      id: 4,
      text: JETCARD_STATUS.EXHAUSTED,
      expanded: true,
      checkIndeterminateField: false,
    },
    {
      id: 7,
      text: JETCARD_STATUS.PAYMENT_DUE,
      expanded: true,
      checkIndeterminateField: false,
    },
    {
      id: 8,
      text: JETCARD_STATUS.AWAITING_APPROVAL,
      expanded: true,
      checkIndeterminateField: false,
    },
  ],
};
const initialState: any = {
  promotionFilter: {
    promotionName: '',
    startDate: '',
    endDate: '',
    promotionType: '',
    promotionStatus: PromotionStatusText[PromotionStatus.Live],
  },
  promotionFilterloaded: false,
  dataState: {
    filter: {
      filters: [
        { field: 'promotionStatus', operator: 'eq', value: PromotionStatus.Live },
      ],
      logic: 'and',
    },
    sort: [ { field: 'id', dir: 'desc' } ],
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
  },

  agrementFilter: {
    cardType: '',
    clientName: '',
    promotion: '',
    brokers: [],
    displayName: '',
    startCreatedDate: '',
    endCreatedDate: '',
    hideFundsForClient: false,
  },
  agrementFilterloaded: false,
  agrementDataState: {
    filter: {
      filters: [],
      logic: 'and',
    },
    sort: [ { field: 'jetcardid', dir: 'desc' } ],
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
  },
  contactJetCardFilter: initialContactJetCardFilter,
  additionalTermsFilter: initialTermsFilter,
  additionalTermsDataState: initialTermsDataState,
  promotionalTermsFilter: initialTermsFilter,
  promotionalTermsDataState: initialTermsDataState,
  statementsFilter: {
    name: '',
  },
  statementsDataState: {
    filter: {
      filters: [],
      logic: 'and',
    },
    sort: [],
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
  },
};

const JetCardReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case type.JETCARD_PROMOTION_FILTER_CHANGE_HANDLER:
      return {
        ...state,
        promotionFilter: { ...action.payload },
      };
    case type.JETCARD_FILTER_LOADED:
      return {
        ...state,
        dataState: action.payload,
      };
    case type.JETCARD_AGREMENT_FILTER_CHANGE_HANDLER:
      return {
        ...state,
        agrementFilter: { ...action.payload },
      };
    case type.JETCARD_AGREMENT_FILTER_LOADED:
      return {
        ...state,
        agrementDataState: action.payload,
      };
    case type.CONTACT_JETCARD_FILTER :
      return{
        ...state ,
        contactJetCardFilter : action.payload,
      };
    case type.JETCARD_ADDITIONAL_TERMS_FILTER_LOADED:
      return {
        ...state,
        additionalTermsDataState: action.payload,
      };
    case type.JETCARD_ADDITIONAL_TERMS_FILTER_CHANGE_HANDLER:
      return {
        ...state,
        additionalTermsFilter: { ...action.payload },
      };
    case type.JETCARD_PROMOTIONAL_TERMS_FILTER_LOADED:
      return {
        ...state,
        promotionalTermsDataState: action.payload,
      };
    case type.JETCARD_PROMOTIONAL_TERMS_FILTER_CHANGE_HANDLER:
      return {
        ...state,
        promotionalTermsFilter: { ...action.payload },
      };
    case type.JETCARD_STATEMENTS_FILTER_LOADED:
      return {
        ...state,
        statementsDataState: action.payload,
      };
    case type.JETCARD_STATEMENTS_FILTER_CHANGE_HANDLER:
      return {
        ...state,
        statementsFilter: { ...action.payload },
      };
    default:
      return state;
  }
};

export default JetCardReducer;
